import { createContext } from 'react';

const UserContext = createContext({
  test:'ABC'
});

export default UserContext;
